import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  unavailableMessage: {
    defaultMessage: 'Your bank is temporarily unavailable',
    id: 'ProviderUnavailable.unavailableMessage',
  },
  tryAgain: {
    defaultMessage: 'Please try again later.',
    id: 'ProviderUnavailable.tryAgain',
  },
  selectAnother: {
    defaultMessage: 'Select another bank',
    id: 'ProviderUnavailable.selectAnother',
  },
});
